import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=64f75b1a&"
import script from "./Cross.vue?vue&type=script&lang=js&"
export * from "./Cross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports